require('/opt/odin/app/frontend/components/blog/card/index.module.scss');module.exports = "../../app/cells/components/blog/card/show.erb";